import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {withStyles} from '@material-ui/core/styles';
import {AnimationRotate} from './Style'
import { IoIosArrowForward} from "react-icons/io";

class TableHeadEvent extends React.Component {


    _renderCell = (Name, Trad, classes, none) => {
      if (none)
      {
        return (
          <div style={{display: 'flex', flexDirection: 'row', fontSize: '0.85em', color: 'black', fontWeight: 'bold'}}>
            <p>{Trad}</p>
            <div style={{marginLeft: 5}}>
              <IoIosArrowForward  color={'rgba(0,0,0,0)'} size={15} />
            </div>
          </div>
        )
      }
      return (
        <div onClick={() => this.props.refParent._sortByAlphabet(Name)} style={{display: 'flex', flexDirection: 'row', fontSize: '0.85em', color: 'black', fontWeight: 'bold'}}>
          <p>{Trad}</p>
          <div style={{marginLeft: 5}}>
            <IoIosArrowForward className={this.props.refParent.state.sortFilter[Name] === 'down' ? classes.spin : classes.refresh} color={'black'} size={15} />
          </div>
        </div>
      )
    }


 render() {
   const { classes } = this.props

   return (
      <TableHead>
        <TableRow>
          <TableCell align="left">{this._renderCell("Image", 'PHOTO', classes, true)}</TableCell>
          <TableCell align="left">{this._renderCell("Name", 'NOM', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("DateEvent", 'DATE', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("BeginHours", 'DEBUT', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("EndHours", 'FIN', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("NumberSubscribe", 'INSCRIPTIONS', classes, true)}</TableCell>
          <TableCell align="left">{this._renderCell("Location", 'LIEUX', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("HeaderLiner", 'AFFICHE', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("PublicUrlSubscribe", 'URL', classes, true)}</TableCell>
          <TableCell align="center">{this._renderCell("ACTION", 'ACTION', classes, true)}</TableCell>
        </TableRow>
      </TableHead>

   )
 }
}


export default withStyles(AnimationRotate)(TableHeadEvent);
